import React, { useState } from 'react'

import { Box, Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { ConfirmationDialog, MenuButton, Permitted } from 'components'
import { RiskAssumedDialog } from '../../../../components'

import useAuth from 'hooks/useAuth'
import usePermissions from 'hooks/usePermissions'
import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import { routes } from 'Routes'
import * as service from 'service'
import helpers from 'helpers'

const ActionButtons = ({ privacyByDesign, refresh }) => {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [selectedAction, setSelectedAction] = useState(null)
  const [openRiskAssumedDialog, setOpenRiskAssumedDialog] = useState(false)

  const { user } = useAuth()
  const permissions = usePermissions()
  const history = useHistory()
  const snackbar = useSnackbar()

  const isResponsible = privacyByDesign?.responsibleUser?.id === user?.id
  const hasManage = permissions.permitted(
    constants.permissions.PRIVACY_BY_DESIGN.MANAGE,
  )
  const canEditOrRespond = isResponsible || hasManage

  const {
    ACTIVATE_ACTION_BUTTON_STATUS,
    APPROVED_STATUS_LABEL,
    CONFIRMATION_CHANGE_STATUS_TEXTS,
    DISAPPROVED_STATUS_LABEL,
    INACTIVE_STATUS_LABEL,
    PENDING_STATUS_LABEL,
    REOPEN_ACTION_BUTTON_STATUS,
    RISK_ASSUMED_STATUS_LABEL,
    SOFT_DELETE_STATUS_LABEL,
    STATUSES,
  } = constants.privacyByDesign

  const isInactive = INACTIVE_STATUS_LABEL === privacyByDesign?.status

  const redirectToEdit = () =>
    history.push(
      reverse(routes.privacyByDesign.edit, {
        privacyByDesignId: privacyByDesign?.id,
      }),
    )

  const redirectToShow = () =>
    history.push(
      reverse(routes.privacyByDesign.show, {
        privacyByDesignId: privacyByDesign?.id,
      }),
    )

  const handleOpenConfirmationDialog = () => setOpenConfirmationDialog(true)
  const handleOpenRiskAssumedDialog = () => setOpenRiskAssumedDialog(true)

  const handleSelectAction = (action) => setSelectedAction(action)

  const handleConfirm = async (status) => {
    try {
      if (
        [REOPEN_ACTION_BUTTON_STATUS, ACTIVATE_ACTION_BUTTON_STATUS].includes(
          status,
        )
      ) {
        status = PENDING_STATUS_LABEL
      }

      await service.dponet.privacyByDesign.changeStatus({
        privacyByDesignId: privacyByDesign?.id,
        status,
      })

      snackbar.open({
        message: `Projeto passou para o status: ${STATUSES[status]} com sucesso.`,
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error.response.data.error) ||
          'Erro ao alterar status do projeto.',
        variant: 'error',
      })
    } finally {
      setOpenConfirmationDialog(false)
    }
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <MenuButton>
          <Button color="secondary" fullWidth onClick={redirectToShow}>
            Visualizar
          </Button>
          {canEditOrRespond && (
            <>
              {PENDING_STATUS_LABEL === privacyByDesign?.status && (
                <Button color="secondary" fullWidth onClick={redirectToEdit}>
                  Editar
                </Button>
              )}
              {DISAPPROVED_STATUS_LABEL === privacyByDesign?.status && (
                <Button
                  color="secondary"
                  fullWidth
                  onClick={handleOpenRiskAssumedDialog}
                >
                  Assumir Risco
                </Button>
              )}
            </>
          )}
          <Permitted tag={constants.permissions.PRIVACY_BY_DESIGN.MANAGE}>
            {[
              APPROVED_STATUS_LABEL,
              DISAPPROVED_STATUS_LABEL,
              RISK_ASSUMED_STATUS_LABEL,
            ].includes(privacyByDesign?.status) && (
              <Button
                color="secondary"
                fullWidth
                onClick={() => {
                  handleSelectAction(REOPEN_ACTION_BUTTON_STATUS)
                  handleOpenConfirmationDialog()
                }}
              >
                Reabrir
              </Button>
            )}
            <Button
              color="secondary"
              fullWidth
              onClick={() => {
                if (isInactive) {
                  handleSelectAction(ACTIVATE_ACTION_BUTTON_STATUS)
                } else {
                  handleSelectAction(INACTIVE_STATUS_LABEL)
                }
                handleOpenConfirmationDialog()
              }}
            >
              {isInactive ? 'Ativar' : 'Inativar'}
            </Button>
            <Button
              color="secondary"
              fullWidth
              onClick={() => {
                handleSelectAction(SOFT_DELETE_STATUS_LABEL)
                handleOpenConfirmationDialog()
              }}
            >
              Excluir
            </Button>
          </Permitted>
        </MenuButton>
      </Box>
      <RiskAssumedDialog
        open={openRiskAssumedDialog}
        setOpen={setOpenRiskAssumedDialog}
        privacyByDesignId={privacyByDesign?.id}
        service={service.dponet.privacyByDesign}
        refresh={refresh}
      />
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        actionAcceptButton={() => handleConfirm(selectedAction)}
        text={CONFIRMATION_CHANGE_STATUS_TEXTS?.[selectedAction]}
        textButton="Confirmar"
      />
    </>
  )
}

export default ActionButtons
